import { authService } from '@/service/AuthService.ts';
import { useAuthStore } from '@/store/AuthStore.ts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router-dom';
import MessageSheet from './MessageSheet.tsx';

const AdminGuard = () => {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      await authService.getUser();
      setIsChecking(false);
    };

    checkAdmin();
  }, []);

  if (isChecking) {
    return <MessageSheet message={t('loading.text')} />;
  }

  if (!user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminGuard;
